<template>
  <div>
    <app-header title=""></app-header>

    <div class="container my-5">
      <h2>Utilization</h2>

      <div class="card">
        <div class="card-body">
          <h3 class="card-title">Weekly Recorded Hours</h3>
          <div v-if="loading" class="py-5 text-center">
            <span class="spinner-border text-primary"></span>
          </div>
          <weekly-hours-chart v-else :columns="utilization.weeklyTotals || []" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { RESET_UTILIZATION } from 'vx/mutations'
import WeeklyHoursChart from './charts/WeeklyHoursChart'

export default {
  components: {
    WeeklyHoursChart
  },

  data () {
    return {
      loading: true
    }
  },

  computed: {
    ...mapState('utilization', ['utilization'])
  },

  created () {
    this[RESET_UTILIZATION]()
    this.getUtilizationData({}).finally(() => {
      this.loading = false
    })
  },

  methods: {
    ...mapActions('utilization', ['getUtilizationData']),
    ...mapMutations('utilization', [RESET_UTILIZATION])
  }
}
</script>
